import React from "react";
import PropTypes from "prop-types";
import "./ToggleSwitch.scss";
import classNames from "classnames";

const ToggleSwitch = ({ id, name, checked, onChange, small, disabled }) => {
  const onKeyDownHandler = (event) => {
    event.preventDefault();
    if (event.keyCode !== 32) return;
    onChange?.(!checked);
  };

  const onKeyChangeHandler = (event) => {
    onChange?.(event.target.checked);
  };

  if (!id) {
    return null;
  }

  return (
    <div className={classNames("toggle-switch", { "small-switch": small })}>
      <input
        type="checkbox"
        name={name}
        className="toggle-switch-checkbox"
        id={id}
        checked={checked}
        onChange={onKeyChangeHandler}
        disabled={disabled}
      />

      <label
        className="toggle-switch-label"
        htmlFor={id}
        tabIndex={disabled ? -1 : 1}
        onKeyDown={onKeyDownHandler}
      >
        <span
          className={classNames("toggle-switch-inner", {
            "toggle-switch-disabled": disabled,
          })}
          tabIndex={-1}
        />
        <span
          className={classNames("toggle-switch-switch", {
            "toggle-switch-disabled": disabled,
          })}
          tabIndex={-1}
        />
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  small: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleSwitch;
